module.exports = __webpack_public_path__ + "2e8e68b5f234bed46d203dfa3a9dfb0c.png";